/** Explicit report fallback stack survives SVG serialization into PNG. */
export const ENERGY_REPORT_SVG_FONT_FAMILY = "-apple-system, \"system-ui\", \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\""
